import React, { type ReactNode } from 'react';
import IconHelp from '@components/icons/IconHelp';
import IconReset from '@components/icons/IconReset';
import { CollapseToggle } from '@components/Collapse';
import { TipWrapper } from '@components/TipWrapper';

interface Props {
  title: ReactNode;
  btns?: ReactNode;
  hideCollapse?: boolean;
  onHelpClick?: () => void;
  onResetClick?: () => void;
}

function SidebarHeader({
  title,
  btns,
  hideCollapse,
  onHelpClick,
  onResetClick,
}: Props) {
  return (
    <div className="mb-10 flex h-50 items-center justify-between rounded bg-black-#28 px-10">
      {title}
      <div className="flex items-center">
        {!!btns && btns}
        {!!onHelpClick && (
          <TipWrapper
            className="ml-10"
            text="快速了解该功能"
            placement="bottom"
            size="sm"
          >
            <IconHelp onClick={onHelpClick} />
          </TipWrapper>
        )}
        {!!onResetClick && (
          <TipWrapper
            className="ml-10"
            text="恢复默认设置"
            placement="bottom"
            size="sm"
          >
            <IconReset onClick={onResetClick} />
          </TipWrapper>
        )}
        {!hideCollapse && (
          <CollapseToggle className="ml-10" dataPlace="bottom" />
        )}
      </div>
    </div>
  );
}

export default SidebarHeader;
